/* eslint-disable camelcase */
import { useAuth0 } from '@auth0/auth0-react'
import { requestGET, requestPATCH } from '../services/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Device } from '../utils/models'
import { ChartTab } from '../utils/chartConfig'

export interface IotDeviceResponse {
  _id: string
  device_id: string
  device_name: string
  issue_ids: string[]
  description?: string
  cert_pem: string
  status: {
    last_message_seen?: Date
    total_messages: number
    is_online: boolean
  }
  chart_configs: ChartTab[]
}

export const useDevices = (limit?: number) => {
  const auth = useAuth0()
  return useQuery<{
    items: Array<Device>
    metadata: { total_count: number; count: number; continuation_token: string }
  }>({
    queryKey: ['devices', limit],
    queryFn: async () => {
      const response = requestGET(
        limit ? `iot/devices?limit=${limit}` : `iot/devices`,
        undefined,
        auth,
      )
      return response
    },
  })
}

export const useDevice = (deviceId: string, organization?: string | null) => {
  const auth = useAuth0()
  return useQuery({
    queryKey: ['device', deviceId],
    queryFn: async (): Promise<IotDeviceResponse> => {
      const path = organization
        ? `iot/devices/${deviceId}?organization_name=${organization}`
        : `iot/devices/${deviceId}`
      console.log(organization)
      console.log(path)
      const response = requestGET(path, undefined, auth)
      return response
    },
  })
}

export const useUpdateDeviceChartConfigs = (
  deviceId: string,
  organization?: string | null,
) => {
  const auth = useAuth0()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (chartConfigs: ChartTab[]) => {
      const path = organization
        ? `iot/devices/${deviceId}?organization_name=${organization}`
        : `iot/devices/${deviceId}`
      return requestPATCH(
        path,
        { body: JSON.stringify({ chart_configs: chartConfigs }) },
        auth,
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['device', deviceId] })
    },
  })
}

